import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 form-check form-switch form-check-reverse" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label fw-medium me-8",
  for: "check"
}, "Toutes les agences ? ", -1)
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Nom et prénom "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Téléphone "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_13 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Email ", -1)
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Sexe "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Rôle "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_23 = { class: "col-md-12" }
const _hoisted_24 = { class: "d-flex align-items-center" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("button", {
  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
  type: "submit"
}, " Modifier un utilisateur ", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_vue_tel_input = _resolveComponent("vue-tel-input")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "userForm",
        onSubmit: _ctx.editUser,
        "validation-schema": _ctx.userSchema,
        "initial-values": _ctx.userForm
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _withDirectives(_createElementVNode("input", {
                onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.chang && _ctx.chang(...args))),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.check) = $event)),
                class: "form-check-input",
                type: "checkbox",
                id: "check"
              }, null, 544), [
                [_vModelCheckbox, _ctx.check]
              ]),
              _createVNode(_component_ErrorMessage, {
                name: "check",
                class: "text-danger"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_Field, {
                  name: "nomComplet",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer le nom et le prénom"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "nomComplet",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_Field, {
                  name: "telephone",
                  modelValue: _ctx.telephone,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.telephone) = $event))
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_vue_tel_input, _mergeProps({
                      placeholder: "Entrer le numéro de téléphone",
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      defaultCountry: "BJ",
                      mode: "international",
                      onValidate: _ctx.validate,
                      class: "shadow-none fs-md-15 text-black py-2"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "onValidate"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "telephone",
                  class: "text-danger"
                }),
                (!_ctx.validPhone)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, "Veuillez entrer un numéro correcte"))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(_component_Field, {
                  type: "email",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer l'email",
                  name: "email"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "email",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_component_Field, {
                  name: "sexe",
                  type: "text"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      searchable: true,
                      options: ['Masculin', 'Féminin'],
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, { placeholder: "Sélectionner le sexe" }), null, 16, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "sexe",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createVNode(_component_Field, { name: "role" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.roleOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label",
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, { placeholder: "Sélectionner le rôle" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "role",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createVNode(_component_router_link, {
                  to: "/liste-users",
                  class: "btn btn-danger transition border-0 lh-1 fw-medium"
                }, {
                  default: _withCtx(() => [
                    _hoisted_26,
                    _hoisted_27,
                    _createTextVNode("Annuler")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "initial-values"])
    ])
  ]))
}